import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnSmall, mixinResetBtnCss, mixinBtnCorporate, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";
import {Link, LinkProps} from "react-router-dom";

interface IProps
    extends IBtnDefaultProps, LinkProps {
}

const BtnLinkCorporateSmallDefault: React.FC<IProps> = (props) => {

    const { icon, ...ButtonProps } = props;

    return (<Link {...ButtonProps} />)

};

const BtnLinkCorporateSmall = styled(BtnLinkCorporateSmallDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnSmall}
    ${mixinBtnCorporate}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnLinkCorporateSmall;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_link_corporate_small.tsx